import React from 'react';
import StatusPage from './StatusPage.jsx';

export const UnauthorizedPage = () => (
  <StatusPage code="401" icon="fas fa-lock" title="Unauthorized" message="You need to sign in to view this page." showLogin />
);
export const ForbiddenPage = () => (
  <StatusPage code="403" icon="fas fa-ban" title="Forbidden" message="Your account does not have permission to access this page." />
);
export const NotFoundPage = () => (
  <StatusPage code="404" icon="fas fa-compass" title="Page not found" message="The page you are looking for does not exist or may have been moved." />
);
export const ServerErrorPage = () => (
  <StatusPage code="500" icon="fas fa-triangle-exclamation" title="Server error" message="Something went wrong on our side. Please try again later." />
);
